
export const setData = (name,token) => {
    localStorage.setItem(name, token);
};

export const getData = (name) => {
    var str=""
    try{
        str = localStorage.getItem(name)
    } catch(e){
        str=""
    }
    return str;
};

export const clearData = (name) => {
    localStorage.removeItem(name);
};